var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_15356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9999,
    r: 15,
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6784 14.3395C18.1754 14.3395 17.7686 14.7462 17.7686 15.2478C17.7686 15.7494 18.1754 16.1567 18.6784 16.1567C19.1814 16.1567 19.5862 15.7499 19.5862 15.2478C19.5862 14.7457 19.1794 14.3395 18.6784 14.3395Z",
    fill: "#C21C05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4138 14.3395C9.91072 14.3395 9.50391 14.7462 9.50391 15.2478C9.50391 15.7494 9.91072 16.1567 10.4138 16.1567C10.9168 16.1567 11.3216 15.7499 11.3216 15.2478C11.3216 14.7457 10.9148 14.3395 10.4138 14.3395Z",
    fill: "#C21C05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5461 14.3395C14.0431 14.3395 13.6362 14.7462 13.6362 15.2478C13.6362 15.7494 14.043 16.1567 14.5461 16.1567C15.0492 16.1567 15.4539 15.7499 15.4539 15.2478C15.4539 14.7457 15.0471 14.3395 14.5461 14.3395Z",
    fill: "#C21C05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.253357C7.32711 0.253357 0.253418 7.32704 0.253418 16C0.253418 24.6729 7.32711 31.7466 16 31.7466C24.673 31.7466 31.7467 24.6729 31.7467 16C31.7467 7.32704 24.673 0.253357 16 0.253357ZM22.4541 19.414C22.4541 20.3474 21.6905 21.1113 20.7567 21.1113H16.0191L12.1894 25.5234V21.1113H8.33354C7.39967 21.1113 6.63611 20.3474 6.63611 19.414V11.0822C6.63611 10.1485 7.39961 9.38492 8.33354 9.38492H20.7567C21.6906 9.38492 22.4542 10.1485 22.4542 11.0822L22.4541 19.414ZM25.364 16.5057C25.364 17.4195 24.6305 18.1705 23.7247 18.2018V11.0822C23.7247 9.44804 22.392 8.11517 20.7567 8.11517H9.54598C9.57604 7.20854 10.3275 6.47667 11.2414 6.47667H23.6665C24.5984 6.47667 25.364 7.24023 25.364 8.17348V16.5057Z",
    fill: "#C21C05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_15356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.68b5cc08d41fa74c347d94ec06faa5f7.svg";
export { ForwardRef as ReactComponent };